// extracted by mini-css-extract-plugin
export default {"bold":"Total_bold__ikXeF"};